import type { ChangeRequestStateLike } from "@cleo/client-runtime/state/thread-settled";
import { create } from "zustand";

interface ThreadChangeRequestStateStore {
  readonly byThreadKey: ReadonlyMap<string, ChangeRequestStateLike>;
  record: (threadKey: string, state: ChangeRequestStateLike | null) => void;
}

/**
 * Ephemeral projection shared by every surface that classifies thread
 * lifecycle. The VCS query remains authoritative; this cache only prevents
 * the sidebar and root-session strip from computing different answers from
 * the same readback.
 */
export const useThreadChangeRequestStateStore = create<ThreadChangeRequestStateStore>((set) => ({
  byThreadKey: new Map(),
  record: (threadKey, state) =>
    set((current) => {
      if ((current.byThreadKey.get(threadKey) ?? null) === state) return current;
      const next = new Map(current.byThreadKey);
      if (state === null) next.delete(threadKey);
      else next.set(threadKey, state);
      return { byThreadKey: next };
    }),
}));
